const E = {
  'Email Notifications': 'Email Notifications',
  Template: 'Template',
  Order: 'Order',
  'Invoices - Payment Confirmation': 'Invoices - Payment Confirmation',
  'Invoices - Payment Details': 'Invoices - Payment Details',
  'Invoices - Payment Summary': 'Invoices - Payment Summary',
  'Job Details': 'Job Details',
  SampleDetails: 'Sample Details',
  ParameterDetails: 'Parameter Details',
  'Manage Access': 'Manage Access',
  'Custom Reports': 'Custom Reports',
  'Custom Reports - Select Clients': 'Custom Reports - Select Clients',
  'Custom Reports - Select Date & Format':
    'Custom Reports - Select Date & Format',
  'Custom Reports - Select Jobs': 'Custom Reports - Select Jobs',
  'Custom Reports - Select Samples': 'Custom Reports - Select Samples',
  'Custom Reports - Select Parameters': 'Custom Reports - Select Parameters',
  'Custom Reports - Select Criteria & Generate Your Report':
    'Custom Reports - Select Criteria & Generate Your Report',
  Resources: 'Resources',
  'New Template': 'New Template',
  'New Job': 'New Job',
  'New Order': 'New Order',
  Job: 'Job',
  Overview: 'Overview',
  'eCOC Templates': 'eCOC Templates',
  Jobs: 'Jobs',
  Supplies: 'Supplies',
  Invoices: 'Invoices',
  'Current Users': 'Current Users',
  'Create User': 'Create User',
  'Inactive Users': 'Inactive Users',
  Environmental: 'Environmental',
  Food: 'Food',
  EmailNotificationsSubText:
    'Bureau Veritas can send e-mail notifications to allow you to track the progress of jobs. \nTo enable the function, use the grid below to select the scenarios and type of notifications you would like receive.',
  searchResultsFor: 'Search Results for',
  JobsSearch: 'Jobs & Samples',
  Prepaid: 'Prepaid',
  PrepaidJob: 'Prepaid Job',
  PrepaidOrderRequest:'Prepaid Order Request',
  'New PrepaidOrder':'New Prepaid Order',
  PrepaidRequest: 'Prepaid Request',
  'New PrepaidJob': 'New Prepaid Job',
  'Prepaid Request Queue': 'Prepaid Request Queue',
  SplitReport: 'Split Report',
};

const F = {
  EmailNotificationsSubText:
    'Les Laboratoires Bureau Veritas peuvent vous envoyer des avis par courriel pour vous permettre de suivre la progression de vos dossiers. Pour activer cette fonction, sélectionnez ci-dessous les scénarios et le type d’avis désirés.',
  'Email Notifications': 'Notifications par courriel',
  Template: 'Modèle',
  Order: 'Commande',
  'Invoices - Payment Confirmation': 'Factures – Confirmation de paiement',
  'Invoices - Payment Details': 'Factures –  Détails de paiement',
  'Invoices - Payment Summary': 'Factures – Sommaire des paiements',
  'Job Details': 'Information sur le dossier',
  SampleDetails: 'Information sur l’échantillon',
  ParameterDetails: 'Information sur le paramètre',
  'Manage Access': 'Gérer l’accès',
  'Custom Reports': 'Rapports personnalisés',
  'Custom Reports - Select Clients': 'Rapports personnalisés – Choisir clients',
  'Custom Reports - Select Date & Format':
    'Rapports personnalisés – Choisir date et format',
  'Custom Reports - Select Jobs': 'Rapports personnalisés – Choisir dossiers',
  'Custom Reports - Select Samples':
    'Rapports personnalisés – Choisir échantillons',
  'Custom Reports - Select Parameters':
    'Rapports personnalisés – Choisir paramètres',
  'Custom Reports - Select Criteria & Generate Your Report':
    'Rapports personnalisés – Choisir paramètres et créer rapport',
  'Custom Reports - Select Samples': 'Rapports personnalisés – Choisir échantillons',
  'Custom Reports - Select Parameters': 'Rapports personnalisés – Choisir paramètres',
  'Custom Reports - Select Criteria & Generate Your Report':
    'Rapports personnalisés – Choisir paramètres et créer rapport',
  Resources: 'Ressources',
  'New Template': 'Nouveau modèle',
  'New Job': 'Nouveau dossier',
  'New Order': 'Nouvelle commande',
  Job: 'Dossier',
  Overview: 'Aperçu',
  'eCOC Templates': 'Modèles d’eCDR',
  Jobs: 'Dossiers',
  Supplies: 'Matériel',
  Invoices: 'Factures',
  'Current Users': 'Utilisateurs actuels',
  'Create User': 'Créer un utilisateur',
  'Inactive Users': 'Utilisateurs inactifs',
  Environmental: 'Environnement',
  Food: 'Alimentaire',
  searchResultsFor: 'Résultats de recherche pour',
  JobsSearch: 'dossiers et échantillons',
  Prepaid: 'Prépayé',
  PrepaidJob: 'Dossier Prépayé',
  'New PrepaidOrder': 'Nouveau Commande prépayée',
  PrepaidRequest: 'Demande Prépayé',
  PrepaidOrderRequest: 'Demande de commande prépayée',
  'New PrepaidJob': 'Nouveau dossier Prépayé',
  'Prepaid Request Queue':'Demandes prépayées',
  SplitReport: 'Rapport fractionné',
};

export default { E, F };



// WEBPACK FOOTER //
// ./src/constants/translations/head.js